import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original?._retry && !original?.url?.includes("/auth/")) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (refreshErr) {
        console.warn("Sessione scaduta, refresh token non valido", refreshErr?.response?.status);
      }
    }
    if (error.response?.status === 402 && !window.location.pathname.startsWith("/piano")) {
      window.location.assign("/piano");
    }
    return Promise.reject(error);
  }
);

export function fmtErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore imprevisto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && detail.code === "plan_required") return "plan_required";
  return String(detail);
}

export const fmtEuro = (v) =>
  v == null ? "N/D" : `€${Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtNum = (v) => (v == null ? "N/D" : Number(v).toLocaleString("it-IT"));

export async function runGhlSync(onStep) {
  const { data: start } = await api.post("/integrations/ghl/sync");
  if (start.status !== "running") return start;
  for (let i = 0; i < 400; i++) {
    await new Promise((r) => setTimeout(r, 2500));
    const { data: job } = await api.get("/integrations/ghl/sync-status");
    if (onStep && job.step) onStep(job.step);
    if (job.status === "done" || job.status === "error") {
      return { ...(job.summary || {}), status: job.status };
    }
  }
  throw new Error("Sincronizzazione troppo lunga, ricontrolla tra poco");
}
